import * as Types from '../../../../types.generated';

import * as types from '@src/types';
import { gql } from '@apollo/client';
import { AiRequestThinFragmentDoc } from '../../../contentDetail/premiumPathDetail/PremiumPathDetailContainer.generated';
import { TranslationSetFragmentDoc, CoverImageFragmentDoc, ContentTagMembershipFragmentDoc, ImageUrlsFragmentDoc, MediaFragmentDoc, TrainingResourceVersionFragmentDoc, ContentSharingPermissionFragmentDoc, AutomationFragmentDoc, ContentQrCodeFragmentDoc, AiGenerateModuleRequestFragmentDoc, UserSelectionFragmentDoc, PathInstanceThinFragmentDoc, RichTextDocumentFragmentDoc, ConvertMediaToRichTextDocumentWorkflowFragmentDoc, BlastSentRecordFragmentDoc, TrainingResourceFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditPromptWithAiMutationVariables = Types.Exact<{
  input: Types.EditPromptWithAiInput;
}>;


export type EditPromptWithAiMutation = { __typename?: 'Mutation', editPromptWithAI: { __typename?: 'AIRequestMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, aiRequest?: { __typename?: 'AIRequest', id: string, rejected: boolean, accepted: boolean } | null } };

export type AiRequestFragment = { __typename?: 'AIRequest', requestText?: string | null, id: string, rejected: boolean, accepted: boolean, aiEditPromptRequest?: { __typename?: 'AIEditPromptRequest', id: string, response?: string | null, requestType: Types.EditPromptWithAiType, generationStartedAt?: string | null, generationCompletedAt?: string | null, generationErroredAt?: string | null, prompt: { __typename?: 'Prompt', id: number, uuid: string }, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } }> | null, aiResponseOptions?: Array<{ __typename?: 'AIResponseOption', id: string, index: number, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } }> | null } | null };

export type MediaSuggestionFragment = { __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } };

export type AiResponseOptionFragment = { __typename?: 'AIResponseOption', id: string, index: number, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } };

export type AiEditPromptRequestFragment = { __typename?: 'AIEditPromptRequest', id: string, response?: string | null, requestType: Types.EditPromptWithAiType, generationStartedAt?: string | null, generationCompletedAt?: string | null, generationErroredAt?: string | null, prompt: { __typename?: 'Prompt', id: number, uuid: string }, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } }> | null, aiResponseOptions?: Array<{ __typename?: 'AIResponseOption', id: string, index: number, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } }> | null };

export type GetAiRequestsQueryVariables = Types.Exact<{
  input: Types.GetAiRequestsInput;
}>;


export type GetAiRequestsQuery = { __typename?: 'Query', GetAIRequests: Array<{ __typename?: 'AIRequest', requestText?: string | null, id: string, rejected: boolean, accepted: boolean, aiEditPromptRequest?: { __typename?: 'AIEditPromptRequest', id: string, response?: string | null, requestType: Types.EditPromptWithAiType, generationStartedAt?: string | null, generationCompletedAt?: string | null, generationErroredAt?: string | null, prompt: { __typename?: 'Prompt', id: number, uuid: string }, mediaSuggestions?: Array<{ __typename?: 'MediaSuggestion', id: string, media: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } }> | null, aiResponseOptions?: Array<{ __typename?: 'AIResponseOption', id: string, index: number, isCorrect: boolean, answer: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } }> | null } | null }> };

export type ResolveAiRequestMutationVariables = Types.Exact<{
  input: Types.ResolveAiRequestInput;
}>;


export type ResolveAiRequestMutation = { __typename?: 'Mutation', resolveAIRequest: { __typename?: 'AIRequestMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, aiRequest?: { __typename?: 'AIRequest', id: string, rejected: boolean, accepted: boolean } | null } };

export const MediaSuggestionFragmentDoc = gql`
    fragment MediaSuggestion on MediaSuggestion {
  id
  media {
    id
    mediaUrls {
      ...TranslationSet
    }
    imageUrls {
      ...ImageUrls
    }
  }
}
    ${TranslationSetFragmentDoc}
${ImageUrlsFragmentDoc}`;
export const AiResponseOptionFragmentDoc = gql`
    fragment AIResponseOption on AIResponseOption {
  id
  answer {
    ...TranslationSet
  }
  index
  isCorrect
}
    ${TranslationSetFragmentDoc}`;
export const AiEditPromptRequestFragmentDoc = gql`
    fragment AIEditPromptRequest on AIEditPromptRequest {
  id
  prompt {
    id
    uuid
  }
  response
  requestType
  mediaSuggestions {
    ...MediaSuggestion
  }
  aiResponseOptions {
    ...AIResponseOption
  }
  generationStartedAt
  generationCompletedAt
  generationErroredAt
}
    ${MediaSuggestionFragmentDoc}
${AiResponseOptionFragmentDoc}`;
export const AiRequestFragmentDoc = gql`
    fragment AIRequest on AIRequest {
  ...AIRequestThin
  requestText
  aiEditPromptRequest {
    ...AIEditPromptRequest
  }
}
    ${AiRequestThinFragmentDoc}
${AiEditPromptRequestFragmentDoc}`;
export const EditPromptWithAiDocument = gql`
    mutation EditPromptWithAI($input: EditPromptWithAIInput!) {
  editPromptWithAI(input: $input) {
    success
    error {
      code
    }
    aiRequest {
      ...AIRequestThin
    }
  }
}
    ${AiRequestThinFragmentDoc}`;
export type EditPromptWithAiMutationFn = Apollo.MutationFunction<EditPromptWithAiMutation, EditPromptWithAiMutationVariables>;

/**
 * __useEditPromptWithAiMutation__
 *
 * To run a mutation, you first call `useEditPromptWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPromptWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPromptWithAiMutation, { data, loading, error }] = useEditPromptWithAiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPromptWithAiMutation(baseOptions?: Apollo.MutationHookOptions<EditPromptWithAiMutation, EditPromptWithAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPromptWithAiMutation, EditPromptWithAiMutationVariables>(EditPromptWithAiDocument, options);
      }
export type EditPromptWithAiMutationHookResult = ReturnType<typeof useEditPromptWithAiMutation>;
export type EditPromptWithAiMutationResult = Apollo.MutationResult<EditPromptWithAiMutation>;
export type EditPromptWithAiMutationOptions = Apollo.BaseMutationOptions<EditPromptWithAiMutation, EditPromptWithAiMutationVariables>;
export const GetAiRequestsDocument = gql`
    query GetAIRequests($input: GetAIRequestsInput!) {
  GetAIRequests(input: $input) {
    ...AIRequest
  }
}
    ${AiRequestFragmentDoc}`;

/**
 * __useGetAiRequestsQuery__
 *
 * To run a query within a React component, call `useGetAiRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetAiRequestsQuery, GetAiRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiRequestsQuery, GetAiRequestsQueryVariables>(GetAiRequestsDocument, options);
      }
export function useGetAiRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiRequestsQuery, GetAiRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiRequestsQuery, GetAiRequestsQueryVariables>(GetAiRequestsDocument, options);
        }
export type GetAiRequestsQueryHookResult = ReturnType<typeof useGetAiRequestsQuery>;
export type GetAiRequestsLazyQueryHookResult = ReturnType<typeof useGetAiRequestsLazyQuery>;
export type GetAiRequestsQueryResult = Apollo.QueryResult<GetAiRequestsQuery, GetAiRequestsQueryVariables>;
export const ResolveAiRequestDocument = gql`
    mutation ResolveAIRequest($input: ResolveAIRequestInput!) {
  resolveAIRequest(input: $input) {
    success
    error {
      code
    }
    aiRequest {
      ...AIRequestThin
    }
  }
}
    ${AiRequestThinFragmentDoc}`;
export type ResolveAiRequestMutationFn = Apollo.MutationFunction<ResolveAiRequestMutation, ResolveAiRequestMutationVariables>;

/**
 * __useResolveAiRequestMutation__
 *
 * To run a mutation, you first call `useResolveAiRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveAiRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveAiRequestMutation, { data, loading, error }] = useResolveAiRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveAiRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveAiRequestMutation, ResolveAiRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveAiRequestMutation, ResolveAiRequestMutationVariables>(ResolveAiRequestDocument, options);
      }
export type ResolveAiRequestMutationHookResult = ReturnType<typeof useResolveAiRequestMutation>;
export type ResolveAiRequestMutationResult = Apollo.MutationResult<ResolveAiRequestMutation>;
export type ResolveAiRequestMutationOptions = Apollo.BaseMutationOptions<ResolveAiRequestMutation, ResolveAiRequestMutationVariables>;